<template>
  <div>
    <DirectionSelectDialog />
    <NotifyDialog />
    <SignInDialog />
    <PlayViewDialog />
  </div>
</template>
<script>
import DialogMixin from "@/mixins/dialogMixin";
import DirectionSelectDialog from "./views/components/common/dialog/DirectionSelectDialog.vue";
import NotifyDialog from "./views/components/common/dialog/NotifyDialog.vue";
import SignInDialog from "./views/components/common/dialog/SignInDialog.vue";
import PlayViewDialog from "./views/components/common/dialog/PlayViewDialog.vue";

export default {
  mixins: [DialogMixin],
  components: {
    DirectionSelectDialog,
    NotifyDialog,
    SignInDialog,
    PlayViewDialog,
  },
};
</script>
